export default __webpack_public_path__ + "static/media/logs-default.8fa681ad.svg";